
import { Component, Vue, Prop } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { listMixin } from "@/mixins/listMixin";
import MainHeader from "../../../main/components/main-header/main-header.vue";
import NavLeft from "../../../main/components/nav-left/nav-left.vue";
import Pagination from "@/components/paginaiton.vue";
import {
  GetKnowledgeList,
  GetKnowledgeDetail,
  DelKnowledge,
  EditKnowledge,
  GetZidian,
} from "@/request/content";
@Component({
  components: {
    MainHeader,
    NavLeft,
    Pagination,
  },
})
export default class Name extends mixins(listMixin) {
  private ifShowEdit: any = false;
  private editData: any = {};
  private window: any = window;
  private data: any[] = [];
  private types: any = [];
  private changshangs: any = [];
  private H: any = "";
  private forceUpdate() {
    this.$forceUpdate();
  }
  private getType(type: any, key: any) {
    const params: any = {
      data_type: type,
    };
    GetZidian(this, params).then((res: any) => {
      this[key] = res[type];
    });
  }
  private openEdit(item?: any) {
    if (item) {
      this.editData = JSON.parse(JSON.stringify(item));
    } else {
      this.editData = {};
    }
    this.ifShowEdit = true;
  }
  private editSure() {
    if (!this.editData["药品名称"]) {
      this.$message.warning("请输入药品名称！");
      return;
    }
    if (!this.editData["类别"]) {
      this.$message.warning("请选择类别！");
      return;
    }
    if (!this.editData["商品名"]) {
      this.$message.warning("请输入商品名！");
      return;
    }
    if (!this.editData["规格"]) {
      this.$message.warning("请输入规格！");
      return;
    }
    if (!this.editData["厂商"]) {
      this.$message.warning("请选择厂商！");
      return;
    }

    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      knowledge_base_id: this.editData.knowledge_base_id,
      知识库类型: "西药库",
      类别: this.editData["类别"],
      药品名称: this.editData["药品名称"],
      商品名: this.editData["商品名"],
      规格: this.editData["规格"],
      厂商: this.editData["厂商"],
    };
    EditKnowledge(this, params, loading)
      .then((res: any) => {
        loading.close();
        this.$message.success(this.editData.id ? "编辑" : "新增" + "成功");
        this.ifShowEdit = false;
        this.getList();
      })
      .catch(() => {
        loading.close();
      });
  }
  /**
   * @description 删除
   */
  private deleteOne(item: any, index: any) {
    this.$confirm("确定删除该条记录么？", "删除", {
      customClass: "commonConfirm",
    }).then(() => {
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      const params: any = {
        params: {
          knowledge_base_id: item.knowledge_base_id,
        },
      };
      DelKnowledge(this, params, loading)
        .then((res: any) => {
          loading.close();
          this.$message.success("删除成功");
          if (this.data.length === 1 && this.filters.current_page !== 1) {
            this.filters.current_page--;
          }
          this.getList();
        })
        .catch(() => {
          loading.close();
        });
    });
  }
  /**
   * @description 获取列表
   */
  getList() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params = {
      知识库类型: "西药库",
      类别: this.filters["类别"],
      药品名称: this.filters.search,
      current_page: this.filters.current_page,
      page_count: this.filters.page_count,
    };
    localStorage.setItem("xiyaokuFilter", JSON.stringify(this.filters));
    GetKnowledgeList(this, params, loading)
      .then((res: any) => {
        loading.close();
        this.data = res.datas.datas;
        this.filters.total_count = res.total_count;
        this.filters.total_page = res.total_page;
        if (this.data.length > 0) {
          this.ifShowEmpty = false;
        } else {
          this.ifShowEmpty = true;
        }
      })
      .catch(() => {
        loading.close();
      });
  }
  mounted() {
    this.H = document.body.clientHeight - 100;
    if (localStorage.getItem("xiyaokuFilter")) {
      this.filters = JSON.parse(localStorage.getItem("xiyaokuFilter") as any);
    }
    this.getList();
  }
}
